import { getUserInfoFromServer } from '@tencent/web-base';
import { useCallback, useEffect, useState } from 'react';

type LoginUserInfo = Partial<{
  userid: string;
  nick_name: string;
  avatar: string;
  avatar_type: string;
  avatar_token: string;
  is_default_avatar: number;
  area: string;
  phone: string;
  email: string;
  name: string;
  gender: string;
  position: string;
  department: string;
  telephone: string;
  wemeet_expiretimes: string;
  wemeet_sign: string;
  user_type: string;
  app_id: string;
  corp_name: string;
  vip_level: string;
  issuer_url: string;
  is_reset_password: boolean;
  is_set_nick_name: boolean;
  wemeet_cgi_token: string;
  wemeet_cgi_token_expiretimes: string;
  openid: string;
  user_district: number;
  password_type: number;
  corp_avatar_token: string;
  register_by: string;
  unionid: string;
  appleOpenId: string;
  googleOpenId: string;
  role_id: string;
  qywechat_session_key?: any;
  qywechat_open_userid: string;
  corp_type: string;
  is_tc: boolean;
  hidden_phone: string;
  hidden_email: string;
}>;
export type UserData = LoginUserInfo;
let userInfo: LoginUserInfo | null = null;
const useLogin = () => {
  const [isLogin, setIsLogin] = useState(false);
  const [loginUserInfo, setLoginUserInfo] = useState<LoginUserInfo | null>(null);

  const getUserInfo = useCallback(() => {
    if (userInfo?.userid) {
      setIsLogin(true);
      setLoginUserInfo(userInfo);
      return;
    }
    getUserInfoFromServer()
      .then((res) => {
        if (res?.userid) {
          userInfo = res;
          setIsLogin(true);
          setLoginUserInfo(res);
        } else {
          userInfo = {};
          setIsLogin(false);
          setLoginUserInfo({});
        }
      })
      .catch(() => {
        userInfo = {};
        setIsLogin(false);
        setLoginUserInfo({});
      });
  }, [loginUserInfo]);

  useEffect(() => {
    getUserInfo();
  }, []);

  return {
    isLogin,
    loginUserInfo,
    getUserInfo,
  };
};

export function getUserInfo() {
  return userInfo;
}

export default useLogin;
